export default __webpack_public_path__ + "static/media/SEG-Library-logo.892c397d.png";